import { EventType, SubscriptionPayloadValue } from './settingsTypes';

export function buildSubscriptionsPayload(
  events: EventType[],
): Record<string, SubscriptionPayloadValue> {
  const subscriptions: Record<string, SubscriptionPayloadValue> = {};
  events.forEach((event) => {
    subscriptions[event.id] = {
      subscribed: event.subscribed,
      subscribedByImplication: event.subscribedByImplication,
      seen: event.seen,
    };
  });
  return subscriptions;
}

export function getReferralEoiImplicationHint(
  allEoiSubscribed: boolean,
  referralAcceptedSubscribed: boolean,
): string {
  if (allEoiSubscribed && referralAcceptedSubscribed) {
    return 'Active because you\'re subscribed to "All EOI Submissions" or "Referral Invitation Accepted"';
  }
  if (allEoiSubscribed) {
    return 'Active because you\'re subscribed to "All EOI Submissions"';
  }
  return 'Active because you\'re subscribed to "Referral Invitation Accepted"';
}

export function isReferralEoiRowDisabled(
  saving: boolean,
  eventId: string,
  allEoiSubscribed: boolean,
  referralAcceptedSubscribed: boolean,
): boolean {
  return (
    saving ||
    (eventId === 'EOI_SUBMISSION_FROM_REFERRAL' && (allEoiSubscribed || referralAcceptedSubscribed))
  );
}

export function applyEventToggle(events: EventType[], eventTypeId: string): EventType[] {
  const updatedEvents = events.map((e) => {
    if (e.id === eventTypeId) {
      return {
        ...e,
        subscribed: !e.subscribed,
        subscribedByImplication: false,
      };
    }
    return e;
  });

  if (eventTypeId !== 'ALL_EOI_SUBMISSION' && eventTypeId !== 'REFERRAL_INVITATION_ACCEPTED') {
    return updatedEvents;
  }

  const allEoiEvent = updatedEvents.find((ev) => ev.id === 'ALL_EOI_SUBMISSION');
  const referralAcceptedEvent = updatedEvents.find(
    (ev) => ev.id === 'REFERRAL_INVITATION_ACCEPTED',
  );
  const referralEoiEvent = events.find((ev) => ev.id === 'EOI_SUBMISSION_FROM_REFERRAL');

  const isAllEoiSubscribed = allEoiEvent?.subscribed || false;
  const isReferralAcceptedSubscribed = referralAcceptedEvent?.subscribed || false;
  const shouldAutoEnable = isAllEoiSubscribed || isReferralAcceptedSubscribed;

  return updatedEvents.map((e) => {
    if (e.id !== 'EOI_SUBMISSION_FROM_REFERRAL') {
      return e;
    }

    if (shouldAutoEnable) {
      const wasExplicitlyYes =
        !referralEoiEvent?.subscribedByImplication && referralEoiEvent?.subscribed;

      if (wasExplicitlyYes) {
        return {
          ...e,
          subscribed: true,
          subscribedByImplication: false,
        };
      }

      return {
        ...e,
        subscribed: true,
        subscribedByImplication: true,
      };
    }

    const wasExplicitlySet =
      !referralEoiEvent?.subscribedByImplication && referralEoiEvent?.subscribed;
    if (wasExplicitlySet) {
      return e;
    }

    return {
      ...e,
      subscribed: false,
      subscribedByImplication: false,
    };
  });
}
